import {parse} from "query-string"

export const getQuery = (state, props) => parse(props.location.search) || null
export const getFromQuery = (state, props) => key => parse(props.location.search)[key] || null
export const getFromQuery2 = key => (state, props) => parse(props.location.search)[key] || null
export const getHash = (state, props) => props.location.hash

export const getReservationsInf = (state, props) => {
  const {sortBy, sortDirection, ref, onlyPaid } = parse(state.router.location.search)
  const page = parse(state.router.location.search).page || 0
  const pageSize = parse(state.router.location.search).pageSize || 100

  return fetch(
    `/getreservations?sortBy=${sortBy || "timestamp"}&sortDirection=${sortDirection || -1}`, 
    {
      method: 'GET', 
      headers: { 
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      credentials: "same-origin",
    }
  )
    .then((resp) => resp.json())
    .then(res => {
      const reservations =  res.filter(r => (ref && r._id == ref) || !ref || ref == "")
      return {
        reservations: reservations.slice(
          pageSize * page,
          pageSize * (page + 1),
        ),
        length: reservations.length
      }
    })
}

export const getSessionsInf = (state, props) => {
  const {sortBy, sortDirection, ref } = parse(state.router.location.search)
  const page = parse(state.router.location.search).page || 0
  const pageSize = parse(state.router.location.search).pageSize || 100

  return fetch(
    `/getsessions?sortBy=${sortBy || "in"}&sortDirection=${sortDirection || -1}`, 
    {
      method: 'GET', 
      headers: { 
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      credentials: "same-origin",
    }
  )
    .then((resp) => resp.json())
    .then(res => {
      const sessions = res.filter(r => (ref && r._id == ref) || (ref && r.clientId == ref) || !ref || ref == "")
      return {
        sessions: sessions.slice(
          pageSize * page,
          pageSize * (page + 1),
        ),
        length: sessions.length}
      }
    )
}



// WEBPACK FOOTER //
// ./src/app/admin/store/selectors.js